import { createAction, props } from '@ngrx/store';

export const toggleEditMode = createAction(
  '[UI] Toggle Edit Mode',
  props<{ mode: boolean }>()
);

export const toggleSubmitFeedbackPopover = createAction(
  '[UI] Toggle Submit Feedback Popover'
);
